import React from "react";
import { Box, Typography } from "@mui/material";
import { palette } from "../../../styles/theme";
import type { SpecsValidationIssueMatch } from "../specsValidationIssues";

function getIssuePalette(match: SpecsValidationIssueMatch) {
  if (match.severity === "warning") {
    return {
      border: "#ff9800",
      background: "#fff8e1",
      text: "#8a4b00",
    };
  }

  return {
    border: palette.red.error,
    background: palette.misc.errorBg,
    text: palette.misc.errorText,
  };
}

export function getValidationIssueFrameSx(
  match: SpecsValidationIssueMatch | null
) {
  if (!match) {
    return {};
  }

  const colors = getIssuePalette(match);
  return {
    borderColor: `${colors.border} !important`,
    boxShadow: `inset 3px 0 0 ${colors.border}`,
    bgcolor: colors.background,
  };
}

export function SpecsValidationIssueHint({
  match,
}: {
  match: SpecsValidationIssueMatch | null;
}) {
  if (!match) {
    return null;
  }

  const colors = getIssuePalette(match);
  const [firstMessage, ...remainingMessages] = match.messages;

  return (
    <Typography
      variant="caption"
      sx={{
        display: "block",
        mt: 0.75,
        color: colors.text,
        fontWeight: 600,
        lineHeight: 1.35,
      }}
    >
      {firstMessage}
      {remainingMessages.length > 0
        ? ` (+${remainingMessages.length} more)`
        : ""}
    </Typography>
  );
}

export function SpecsValidationIssueShell({
  match,
  children,
}: React.PropsWithChildren<{
  match: SpecsValidationIssueMatch | null;
}>) {
  if (!match) {
    return <>{children}</>;
  }

  const colors = getIssuePalette(match);

  return (
    <Box
      sx={{
        p: 1,
        border: `1px solid ${colors.border}`,
        borderRadius: 1,
        bgcolor: colors.background,
      }}
    >
      {children}
      <SpecsValidationIssueHint match={match} />
    </Box>
  );
}
